<micro-lookup domain="air" obj="airtimeProducts" url="/air/airtimeProducts" [key]="airtimeProductId" [link]="link"></micro-lookup>
